$(document).on('click', '.password-viewable-button', (e) => {
  var $input_form = $(e.target).closest('.input-group').children('input')
  console.log($input_form)
  console.log($input_form.attr('type'))
  if ($input_form.attr('type') == 'password') {
    $input_form.attr('type', 'text')
  } else {
    $input_form.attr('type', 'password')
  }
});